<div class="cadastro-cartorio-container">
  <div class="header">
    <h1>Cadastro de Cartórios</h1>
    <button class="btn btn-primary" (click)="openModal(formModal, true)">Novo Cartório</button>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroOficial">Oficial:</label>
          <input 
            type="text" 
            id="filtroOficial" 
            class="form-control" 
            [(ngModel)]="filtroOficial"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por oficial">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroRepresentante">Representante:</label>
          <input 
            type="text" 
            id="filtroRepresentante" 
            class="form-control" 
            [(ngModel)]="filtroRepresentante"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por representante">
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-end">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th style="width: 15%;">Nome</th>
          <th style="width: 12%;">Oficial</th>
          <th style="width: 12%;">Representante</th>          
          <th style="width: 20%;">Endereço</th>
          <th style="width: 12%;">CNPJ</th>
          <th style="width: 15%;">E-mail</th>
          <th style="width: 14%;">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cartorio of cartoriosFiltrados">
          <td class="text-truncate" style="max-width: 0;" title="{{ cartorio.nome }}">{{ cartorio.nome }}</td>
          <td class="text-truncate" style="max-width: 0;" title="{{ cartorio.oficial }}">{{ cartorio.oficial }}</td>
          <td class="text-truncate" style="max-width: 0;" title="{{ cartorio.representante }}">{{ cartorio.representante }}</td>
          <td class="text-truncate" style="max-width: 0;" title="{{ cartorio.endereco }}">{{ cartorio.endereco }}</td>
          <td class="text-truncate" style="max-width: 0;" title="{{ cartorio.cnpj }}">{{ cartorio.cnpj }}</td>
          <td class="text-truncate" style="max-width: 0;" title="{{ cartorio.email }}">{{ cartorio.email }}</td>
          <td>
            <button class="btn btn-sm btn-warning me-2" (click)="editarCartorio(cartorio); openModal(formModal)">
              <i class="fa fa-edit"></i> Editar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header">
      <h4 class="modal-title">{{ cartorioSelecionado ? 'Editar Cartório' : 'Novo Cartório' }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-container">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="NOME">Nome: <span style="color: red">*</span></label>
              <input 
                type="text" 
                id="NOME" 
                formControlName="NOME" 
                class="form-control"
                placeholder="Digite o nome do cartório">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="OFICIAL">Oficial: <span style="color: red">*</span></label>
              <input 
                type="text" 
                id="OFICIAL" 
                formControlName="OFICIAL" 
                class="form-control"
                placeholder="Digite o nome do oficial">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="CNPJ">CNPJ: <span style="color: red">*</span></label>
              <input 
                type="text" 
                id="CNPJ" 
                formControlName="CNPJ" 
                class="form-control"
                placeholder="00.000.000/0000-00"
                [textMask]="{mask: cnpjMask}">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="REPRESENTANTE">Representante: <span style="color: red">*</span></label>
              <input 
                type="text" 
                id="REPRESENTANTE" 
                formControlName="REPRESENTANTE" 
                class="form-control"
                placeholder="Digite o nome do representante">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="TELEFONE">Telefone: <span style="color: red">*</span></label>
              <input 
                type="text" 
                id="TELEFONE" 
                formControlName="TELEFONE" 
                class="form-control"
                >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="EMAIL">E-mail: <span style="color: red">*</span></label>
              <input 
                type="email" 
                id="EMAIL" 
                formControlName="EMAIL" 
                class="form-control"
                placeholder="seu@email.com">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="ENDERECO">Endereço: <span style="color: red">*</span></label>
          <textarea 
            id="ENDERECO" 
            formControlName="ENDERECO" 
            class="form-control"
            placeholder="Digite o endereço completo"
            rows="3"></textarea>
        </div>

        <div class="form-group">
          <label for="OBSERVACAO">Observação:</label>
          <textarea 
            id="OBSERVACAO" 
            formControlName="OBSERVACAO" 
            class="form-control"
            placeholder="Digite observações adicionais"
            rows="3"></textarea>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancelar</button>
          <button type="submit" class="btn btn-primary ms-2" [disabled]="!cadastroForm.valid">Salvar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 